export const environment = {
  production: true,
  apiUrl: '',
  googleAnalytics: {
    trackingId_ita: 'G-9LTCY32QGH',
    trackingId_usa: 'G-VK1EYPLQWX',
    trackingId_can: 'G-ZWFPJ5JM1E',
    trackingId_mtc: 'G-9ZH4MX7DMQ',
    trackingId_ecu: 'G-EYX080GRYT'
  },
  msalKeys: {
    clientId:     'b1765b27-29a8-49b8-9aed-1cabd4e26ead',
    clientId_ita: 'f0d9deba-fc51-433b-a614-2cb32de093d4',
    clientId_usa: 'b1765b27-29a8-49b8-9aed-1cabd4e26ead',
    clientId_can: '59b9b936-50e5-4b61-b1df-62d8dd2acc2d', 
    clientId_ecu: '7ce67d93-2c7c-4ca8-bf3f-2e8c2f9c8d59',
    clientId_mtc: '4b0df27e-052b-44ac-a4b9-2a32bf7d72ca',
    clientId_uae: '52cf599c-9610-49bd-a50f-fe516e444b4c',
    authority:    'https://login.microsoftonline.com/a054342c-6f8c-4378-ad61-a8ad00f2b736'
  },
  appInsights: {
    instrumentationKey: 'be5197fe-831b-436e-ae7c-dfbf923f2312'
  },
  team: {
    teamUrl:      'https://team-qa.tenaris.com',
    clientId:     'NFIihCRWRVddThGaNTIz7l4epFfd8HIE',
    clientSecret: '',
    logoutUrl:    'https://team-qa.tenaris.com/oidc/logout'
  },
  access: null,
  audience: 'tpi-sign'
};